// @mui material components
import { Grid } from "@mui/material";
import PropTypes, { number } from "prop-types";

// Kaizen Dashboard components
import SoftTypography from "components/SoftTypography";
import { truncar } from "utils/truncate";
import { valorAPesos } from "utils/truncate";

const tamaños = [1, 7, 1, 2, 1];

function FilaBody({ color = "none", fontColor, data, titulos }) {
  return (
    <Grid container sx={{ backgroundColor: color }} borderBottom={titulos ? "1px solid" : "none"}>
      <Grid
        item
        xs={tamaños[0]}
        sx={{ borderRight: "1px solid" }}
        textAlign="center"
        lineHeight={1}
      >
        <SoftTypography variant="caption" color={fontColor}>
          {data.CodProv}
        </SoftTypography>
      </Grid>
      <Grid
        item
        xs={tamaños[1]}
        sx={{ borderRight: "1px solid" }}
        textAlign="center"
        lineHeight={1}
      >
        <SoftTypography variant="caption" color={fontColor}>
          {data.Descripcion}
        </SoftTypography>
      </Grid>
      <Grid
        item
        xs={tamaños[2]}
        sx={{ borderRight: "1px solid" }}
        textAlign="center"
        pb={color === "none" ? 0.2 : 0}
        lineHeight={1}
      >
        <SoftTypography variant="caption" color={fontColor} lineHeight={1}>
          {data.TALLE ? data.TALLE : ""}
        </SoftTypography>
      </Grid>
      <Grid
        item
        xs={tamaños[3]}
        sx={{ borderRight: "1px solid" }}
        textAlign="center"
        lineHeight={1}
      >
        <SoftTypography variant="caption" color={fontColor} lineHeight={1}>
          {data.COLOR ? data.COLOR : ""}
        </SoftTypography>
      </Grid>
      <Grid
        item
        xs={tamaños[4]}
        sx={{ borderRight: "1px solid" }}
        textAlign="center"
        lineHeight={1}
      >
        <SoftTypography variant="caption" color={fontColor}>
          {data.Cantidad ? (data.Cantidad !== "Cantidad" ? Math.abs(data.Cantidad) : "Cant") : "-"}
        </SoftTypography>
      </Grid>
    </Grid>
  );
}

FilaBody.propTypes = {
  data: PropTypes.object,
  factura: PropTypes.object,
  color: PropTypes.string,
  fontColor: PropTypes.string,
  titulos: PropTypes.bool,
};

export default FilaBody;
